import { Navigate, Route, Routes } from 'react-router-dom';

import Loading from '../components/Loading';
// import { useOnboarding } from '../components/onboarding/useOnboarding';
import WhatsNewModal from '../components/whatsNew/WhatsNewModal';
import { SearchProvider } from '../contexts/SearchContext';
import { SidebarLayout } from '../layouts/SidebarLayout';
import { NotFound } from '../pages/errors/NotFound';
import PatientsOverview from '../pages/Home/PatientsOverview';
import PracticesOverview from '../pages/Home/PracticesOverview';
import Shop from '../pages/Shop';
import { useUser } from '../providers/UserProvider';
import { ClientRoute } from './clientRoute';
export const HomeRoutes = () => {
    const { user, isLoading, isAuthenticated } = useUser();
    // const { shouldShow: shouldShowOnboarding } = useOnboarding();
    if (isLoading) {
        return <Loading />;
    }
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    // if (shouldShowOnboarding) {
    //     return <Navigate to="/onboarding" replace />;
    // }
    const isAdmin = Boolean(user?.database?.data?.isAdmin);
    const hasPracticeIds = user?.database?.data?.practices?.length ?? 0;
    const shouldShowPracticesOverview = isAdmin && !hasPracticeIds;
    return (
        <>
            <WhatsNewModal />
            <Routes>
                {/* User Routes */}
                <Route path="/" element={<Navigate to="home" replace />} />
                <Route
                    path="home"
                    element={
                        <ClientRoute>
                            <SidebarLayout>
                                <SearchProvider storageKey="home">
                                    {shouldShowPracticesOverview ? (
                                        <PracticesOverview />
                                    ) : (
                                        <PatientsOverview />
                                    )}
                                </SearchProvider>
                            </SidebarLayout>
                        </ClientRoute>
                    }
                />

                <Route
                    path="shop"
                    element={
                        <ClientRoute>
                            <SidebarLayout>
                                <Shop />
                            </SidebarLayout>
                        </ClientRoute>
                    }
                />

                {/* 404 - Catch all unmatched routes */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};
